export class AssetMetadataDto {
	uuid!: string;
	tenantOrgId?: string;
	sourceUuid!: string;
	description?: string;
}
